<!-- 选择sku并加入购物车 -->
<template>
  <el-dialog title="Select Type" :close-on-press-escape="false" :close-on-click-modal="false"
    :visible.sync="isShowPopup" @close="closeFn">
    <div class="good_info_box">
      <img :src="goodInfoData.thumbnailCommon" alt="" class="head">

      <div class="info_box">
        <div class="name"></div>
        <div class="line">
          <div class="label">Nicotine Content</div>
          <el-select v-model="nicotine" placeholder="Please select" @change="nicotineCheckChange">
            <el-option v-for="item in nicotineOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="line">
          <div class="label">Coil</div>
          <el-select v-model="flavor" placeholder="Please select">
            <el-option v-for="item in flavorOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="line">
          <div class="label"></div>
          <el-input-number v-model="buyNum" :min="1" />
        </div>
        <div class="line">
          <div class="label"></div>
          <div class="price">${{ numfixed(price * buyNum) }}</div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button :loading="addCarLoading" @click="addCarFn">Add to cart</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      goodInfoData: {},
      isShowPopup: false,
      addCarLoading: false,
      nicotineOptions: [],
      nicotine: "",
      flavorOptions: [],
      flavor: "",
      buyNum: 1,
      price: 0,
    }
  },
  methods: {
    numfixed(num) {
      return num.toFixed(2);
    },
    // 关闭重置数据
    closeFn() {
      this.nicotineOptions = [];
      this.nicotine = "";
      this.flavorOptions = [];
      this.flavor = "";
      this.buyNum = 1;
      this.price = 0;
    },
    // 加入购物车
    async addCarFn() {
      if (this.addCarLoading) return;
      this.addCarLoading = true;
      try {
        const res = await this.$post("system/cart", {
          "goodsId": this.goodInfoData.goodsId, //商品id
          "number": this.buyNum, //数量
          "falvorId": this.flavor, //口味id
          "nicotineId": this.nicotine //尼古丁id
        });
        this.isShowPopup = false;
        var listCar = [];
        listCar.push(this.goodInfoData)
        this.$store.commit('setCarJsonJSON', listCar);
        this.$msg(res.msg || "succeed")
      } catch (e) {
        this.$msg((e || {}).msg, "e")
      }
      this.addCarLoading = false;
    },
    // 尼古丁的选中改变
    nicotineCheckChange() {
      const info = this.goodInfoData.nicotines.find(item => item.nicotineId == this.nicotine);
      if (info) this.price = +info.price || 0;
    },
    // 打开sku选择弹窗
    open(goodInfo) {
      if (goodInfo) {
        this.goodInfoData = goodInfo;
        console.warn(goodInfo, "goodInfo")
        this.flavorOptions = (this.goodInfoData.flavors || []).map(item => {
          return { label: item.name, value: item.falvorId, }
        });
        this.nicotineOptions = (this.goodInfoData.nicotines || []).map(item => {
          return { label: item.content, value: item.nicotineId, }
        });
        if (this.nicotineOptions.length) {
          this.nicotine = this.nicotineOptions[0].value;
          this.price = +this.goodInfoData.nicotines[0].price || 0;
        }
        if (this.flavorOptions.length) this.flavor = this.flavorOptions[0].value;
        this.isShowPopup = true;
      } else this.$msg("未选择有效商品", "e")
    },
  }
}
</script>

<style lang="scss" scoped>
.good_info_box {
  display: flex;
  align-items: flex-start;
  padding-left: 32px;

  .head {
    width: 200px;
    height: 200px;
    object-fit: cover;
    margin-right: 24px;
  }

  .info_box {
    .name {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 12px;
    }

    .line {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .label {
        width: 130px;
        font-size: 14px;
      }

      .price {
        font-size: 20px;
        font-weight: bold;
        color: #f22424;
      }
    }
  }
}
</style>
